/**
 * Legend component entry file8
 */


    require('./legend');

    require('./legend/ScrollableLegendModel');
    require('./legend/ScrollableLegendView');
    require('./legend/scrollableLegendAction');




//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/legendScroll.js
// module id = 1276
// module chunks = 158